export default __webpack_public_path__ + "static/ground-ddc25c954c1c7665854594cac16b0327.png";